import * as React from "react";
import { Card, CardProps, styled } from "@mui/material";

import CheckIcon from "@mui/icons-material/Check";

export type SelectableCardProps = {
  selected?: boolean;
  hideCheckbox?: boolean;
  isDisable?: boolean;
  onClick: () => void;
} & CardProps;

const SelectableCard: React.FC<SelectableCardProps> = (props) => {
  const { children, selected = false, hideCheckbox = false, isDisable = false, onClick } = props;
  return (
    <StyledCard
      variant="outlined"
      aria-selected={selected}
      onClick={onClick}
      sx={{ pointerEvents: isDisable ? "none" : "auto", opacity: isDisable ? 0.5 : 1 }}
    >
      {children}
      {!hideCheckbox && <CheckIcon sx={{ ml: 1 }} fontSize="small" className="MuiCheckIcon" color="primary" />}
    </StyledCard>
  );
};

export default SelectableCard;

const StyledCard = styled(Card)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  paddingTop: theme.spacing(1),
  paddingBottom: theme.spacing(1),
  paddingLeft: theme.spacing(1),
  paddingRight: theme.spacing(2),
  cursor: "pointer",
  transition: "background .3s",

  ".MuiCheckIcon": {
    opacity: 0,
    transition: "opacity .3s",
    flexShrink: 0,
  },

  "&[aria-selected=true]": {
    ".MuiCheckIcon": {
      opacity: 1,
    },
  },
  "&:not([aria-selected=true])": {
    "&:hover": {
      background: theme.palette.backgroundAlpha.hover,
    },
  },
}));
